import { type KeyboardEventHandler, type ReactNode, useCallback } from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { CaretDownIcon } from '@/icons';
import { SelectIcon } from './SelectIcon';
import { SelectTrigger } from './SelectTrigger';
import { SelectValue } from './SelectValue';
import { type SelectOption } from './type';
export const SelectRoot = SelectPrimitive.Root;
type SelectRootProps<T extends string = string> = {
  className?: string;
  children?: React.ReactNode;
  isOpen: boolean;
  open: () => void;
  close: () => void;
  renderedValue?: ReactNode;
  options: SelectOption<T>[];
  error?: boolean;
  placeholder?: string;
  intent?: 'neutral' | 'strong';
  disabled?: boolean;
  trigger?: ReactNode;
};
export const Select = <T extends string,>(props: SelectRootProps<T>) => {
  const {
    open,
    isOpen,
    close
  } = props;
  const handleTriggerKeyDown: KeyboardEventHandler<HTMLButtonElement> = useCallback(e => {
    if (e.key !== ' ') return;
    const target = e.target as HTMLElement;
    if (document.activeElement === target) {
      e.preventDefault();
      isOpen ? close() : open();
    }
  }, [open, close, isOpen]);
  return <SelectRoot open={props.isOpen} data-sentry-element="SelectRoot" data-sentry-component="Select" data-sentry-source-file="SelectRoot.tsx">
      <SelectTrigger tabIndex={0} intent={props.intent} open={props.isOpen} onKeyDown={handleTriggerKeyDown} onClick={props.open} error={props.error} disabled={props.disabled} className={props.className} trigger={props.trigger} data-sentry-element="SelectTrigger" data-sentry-source-file="SelectRoot.tsx">
        <SelectValue placeholder={props.placeholder} data-sentry-element="SelectValue" data-sentry-source-file="SelectRoot.tsx">
          {props.renderedValue}
        </SelectValue>
        <SelectIcon open={props.isOpen} data-sentry-element="SelectIcon" data-sentry-source-file="SelectRoot.tsx">
          <CaretDownIcon size="md" fill={ICON_COLOR.default} data-sentry-element="CaretDownIcon" data-sentry-source-file="SelectRoot.tsx" />
        </SelectIcon>
      </SelectTrigger>
      {props.children}
    </SelectRoot>;
};